import { AddressType } from "@redotech/redo-model/address-collection";
import { AddressSchema } from "@redotech/redo-model/team";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getAddresses = {
  name: "getAddresses" as const,
  input: z.object({ type: createEnum(AddressType).optional() }),
  output: z.object({ addresses: z.array(AddressSchema) }),
};
